class BrixReadMoreButtton {
  static init(...parameters) {
    return new BrixReadMoreButtton(...parameters);
  }

  constructor(block) {
    this.readMoreButton = block;
    this.getElementsBelow();
    this.addReadLessButton();
    this.addEventListeners();
  }

  addReadLessButton() {
    const ids = this.elementsBelow.map((element) => element.id).join(' ');
    this.readMoreButton.setAttribute('aria-controls', ids);
    const parent = this.readMoreButton.parentNode;
    const { readLessLabel } = this.readMoreButton.dataset;

    this.readLessButton = document.createElement('button');
    this.readLessButton.innerHTML = readLessLabel;
    this.readLessButton.classList.add('brix-read-less-button');
    this.readLessButton.classList.add('-hidden');

    // The old SVG
    // const arrowIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    // arrowIcon.setAttribute('viewBox', '0 0 14 9');

    // const arrowIconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    // eslint-disable-next-line max-len
    // arrowIconPath.setAttribute('d', 'M12.2929 0.292892L13.7071 1.70711L7.00001 8.41421L0.292908 1.70711L1.70712 0.292892L7.00001 5.58579L12.2929 0.292892Z');

    // arrowIcon.appendChild(arrowIconPath);
    // this.readLessButton.appendChild(arrowIcon);

    this.readLessButton.setAttribute('aria-expanded', false);
    this.readLessButton.setAttribute('aria-controls', ids);

    parent.appendChild(this.readLessButton);
  }

  getElementsBelow() {
    const children = this.readMoreButton.parentNode.childNodes;
    const elemIndex = [...children].indexOf(this.readMoreButton);

    this.elementsBelow = [];
    [...children].forEach((child, index) => {
      if (child.nodeType === 1 && index > elemIndex) {
        this.elementsBelow.push(child);
      }
    });

    this.elementsBelow.forEach((element) => {
      element.classList.add('-hidden');
    });
  }

  addEventListeners() {
    this.readMoreButton.addEventListener('click', () => {
      this.readMoreButton.classList.add('-hidden');
      this.readMoreButton.setAttribute('aria-expanded', true);
      this.readLessButton.setAttribute('aria-expanded', true);
      this.readLessButton.classList.remove('-hidden');
      this.elementsBelow.forEach((element) => {
        element.classList.remove('-hidden');
      });
      this.readLessButton.focus();
    });

    this.readLessButton.addEventListener('click', () => {
      this.readMoreButton.classList.remove('-hidden');
      this.readLessButton.classList.add('-hidden');
      this.readMoreButton.setAttribute('aria-expanded', false);
      this.readLessButton.setAttribute('aria-expanded', false);
      this.elementsBelow.forEach((element) => {
        element.classList.add('-hidden');
      });
      this.readMoreButton.focus();
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-read-more-button', BrixReadMoreButtton.init);
}
